import { render, staticRenderFns } from "./TenantDocumentsTab.vue?vue&type=template&id=728dc50a&scoped=true"
import script from "./TenantDocumentsTab.vue?vue&type=script&lang=ts"
export * from "./TenantDocumentsTab.vue?vue&type=script&lang=ts"
import style0 from "./TenantDocumentsTab.vue?vue&type=style&index=0&id=728dc50a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728dc50a",
  null
  
)

export default component.exports